export default "__VITE_ASSET__Cl0N1bbc__"